/**
 * Add any additional error codes that need to be tracked
 * for form group controls
 * NOTE: Name the enum the same as the value when using an ErrorStateMatcher
 */
export enum FormGroupErrorCodes {
  required = "required",
  minlength = "minlength",
  maxlength = "maxlength",
  min = "min",
  max = "max",
  maskError = "Mask error",
  pattern = "pattern",
  serverError = "serverError",
  invalidRange = "invalidRange",
  matStartDateInvalid = "matStartDateInvalid",
  matEndDateInvalid = "matEndDateInvalid",
  matDatepickerMin = "matDatepickerMin",
  matDatepickerMax = "matDatepickerMax",
  confirmMatch = "confirmMatch"
}
